export default __webpack_public_path__ + "static/screenshot-editor-257f190c8caeed23ffcf40d764933173.jpg";